<template>
  <div>
    <!--发起申请Dialog-->
    <div class="css-jl1qws open-proc d-dialog animate-left-in" :class="{active: showThis}">
      <div class="sc-bdVaJa keQvRI"></div>
      <div class="css-wgk558">
        <div class="css-7bwbxg">
          <div class="d-content">
            <header class="c title-head">
              <h1>发起申请</h1>
              <a href="javascript:void(0);" class="c a-btn" title="关闭" @click.stop="closeDialog">
                <svg width="24" height="24" viewBox="0 0 24 24" focusable="false" role="presentation">
                  <path
                      d="M12 10.586L6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414L12 10.586z"
                      fill="currentColor"></path>
                </svg>
              </a>
            </header>
            <div class="main-body">
              <div class="dialog-content">
                <div v-for="(iconBtn, i) in procInfo" :key="i">
                  <h3>{{ iconBtn.title }}</h3>
                  <div class="d-sqs">
                    <div v-for="(btn, btni) in iconBtn.btns" :key="btni" class="sq-btn c" @click.stop="openDialog(iconBtn.title, btn.subTitle)">
                      <img class="icon-btn" :src="btn.imgIcon" alt="">
                      <img src="../assets/imgs/qus1.svg" class="icon icon-tr" @mouseenter="$tip('查看流程图')" @click.stop="liuchengImg(iconBtn.title, btn.subTitle);" alt="">
                      <p>{{ btn.subTitle }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ImgViewer ref="imgViewer"></ImgViewer>
  </div>
</template>
<script>
import ProcInfo from "@/assets/models/ProcInfo";
import ImgViewer from "@/components/ImgViewer";

export default {
  data() {
    return {
      showThis: false,
      procInfo: ProcInfo.info,
      src: null
    }
  },
  components: {ImgViewer},
  inject: ['componentShenpi'],
  methods: {
    openDialog(title, subTitle) {
      this.$router.push({
        name: '流程',
        params: {
          id: 0,
          title: title,
          subTitle: subTitle,
          backUrlName: '审批系统'
        }
      })
    },
    liuchengImg(title, subTitle) {
      let imgs = ProcInfo.procImgs();
      let curImg = `/images/proc/${title}-${subTitle}.jpg`
      let i = imgs.indexOf(curImg);
      this.$refs.imgViewer.init(imgs, i, false)
    },
    closeDialog() {
      this.showThis = false;
      let self = this;
      setTimeout(() => self.$router.push('/sp'), 300)
    }
  },
  mounted() {
    this.showThis = true
  }
}
</script>
